var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-header-img"},[_c('c-img-ratio',{attrs:{"aspect":"s100","src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }